import { columnHelper } from './helper';

export const name = columnHelper.accessor('ID', {
  header: 'Name',
  id: 'name',
});
